import $api from '../services';

export default {
    list(params) {
        return $api.get('/business', params);
    },
    create(params) {
        return $api.post('/business', params);
    },
    read(id) {
        return $api.get(`/business/${id}`);
    },
    update(id, params) {
        return $api.put(`/business/${id}`, params);
    },
    updateStatus(id, param) {
        return $api.put(`/business/${id}/status`, param);
    },
    resetPassword(id) {
        return $api.post(`/business/${id}/reset-password`);
    },
    delete(id) {
        return $api.delete(`/business/${id}`);
    },
    setMembersPassword(id, params) {
        return $api.post(`/business/${id}/set-members-password`, params);
    },
    sendPush(id, params) {
        return $api.post(`/business/${id}/send-push`, params);
    },
    /**
     * Admin activity report (unique logins / unique meditated users).
     * @param {{ businessId?: string, dateFrom: string, dateTo: string }} params
     */
    activityReport(params) {
        return $api.get('/business/activity-report', params);
    },
    /**
     * Admin list of members who have never logged in (all time).
     * @param {{ businessId?: string }} params omit businessId for platform-wide
     */
    neverLoggedInUsers(params) {
        return $api.get('/business/activity-report/never-logged-in', params);
    }
};
